import { getConfig } from '@cian/config/browser';
import { parseCookies } from '@cian/utils';
import { pathOr } from 'ramda';
import { getViewportDimensions } from '../../utils/getViewportDimensions';
import { fetchTeaser } from '../../repositories/teaser';
import { ITeaserEvent, ITeaserItem } from './types';

export const sendTeaserEvent = (items: ITeaserItem[]) => {
  const abGroup = getConfig().get<number>('abGroup');
  const defaultPage = { pageType: undefined, siteType: undefined };
  const page = pathOr(defaultPage, ['CianAnalytics', 'service', 'config', 'page'], window);

  const event: ITeaserEvent = {
    user_id: window.__header_user_id__,
    pageType: page.pageType,
    device_type: page.siteType,
    ab_group: abGroup,
    viewport: getViewportDimensions(),
    cid: parseCookies(document.cookie)['_CIAN_GK'],
    items,
  };

  fetchTeaser(event);
};
